import ALink, { type ALinkProps } from 'tradera/components/alink/alink';

export const MaybeLink = ({ href, children, ...otherProps }: ALinkProps) => {
    if (href) {
        return (
            <ALink href={href} {...otherProps}>
                {children}
            </ALink>
        );
    }
    return <>{children}</>;
};
